module.exports = __webpack_public_path__ + "static/media/Flechas-26.3bb11e0a.svg";